export default __webpack_public_path__ + "static/media/metamask.b7a0f634.png";